import { useMemo } from 'react';

import { inboxPathsFor } from './repositories/inbox-repo.js';
import { useAuth } from './use-auth.js';
import { usePlatformBrand } from './use-platform-brand.js';

/**
 * The inbox collections the signed-in person reads — their own, plus the
 * brand's shared admin queue when they are a super-admin of THIS brand
 * (ADR-0017: scoped per brand, `superadmin: { [brandId]: true }`).
 *
 * Returns a stable array (null when signed out) so it can key a listener.
 */
export function useInboxPaths(): readonly string[] | null {
  const { user, claims } = useAuth();
  const brand = usePlatformBrand();
  const uid = user?.uid ?? null;
  const superAdminBrandId = isSuperAdminOf(claims, brand.id) ? brand.id : null;
  return useMemo(
    () => (uid ? inboxPathsFor(uid, superAdminBrandId) : null),
    [uid, superAdminBrandId],
  );
}

function isSuperAdminOf(claims: Record<string, unknown> | null, brandId: string): boolean {
  const sa = claims?.['superadmin'];
  return typeof sa === 'object' && sa !== null && (sa as Record<string, unknown>)[brandId] === true;
}
